import { LinkCard } from '@/components/elements/LinkCard'
import { LinkCardList } from '@/components/elements/LinkCardList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'

export const More = () => {
  return (
    <div>
      <SectionTitle titleText="More" subTitleText="その他" color="normal" />
      <Spacer h={{ sp: 40, pc: 70 }} />
      <LinkCardList>
        <LinkCard
          title="メディアキット"
          link="/news/media/"
          imgPath="/images/news-media-kit.svg"
        />
        <LinkCard
          title="ビデオライブラリー"
          link="/news/video/"
          imgPath="/images/news-video-library.svg"
        />
        <LinkCard
          title="メディア露出一覧"
          link="/news/exposure/"
          imgPath="/images/news-media-exposure.svg"
        />
      </LinkCardList>
    </div>
  )
}
